<template>
  <div
    class="feature-card"
    :class="{ 'feature-card--centered': centered }"
    :style="{ 'background-color': background_color }"
  >
    <!-- icona -->
    <div
      v-if="icon"
      class="feature-card__icon"
      :class="{ 'feature-card__icon--round': radius }"
      :style="{ background: icon_background_color }"
    >
      <vb-icon :name="icon" :size="24" :color="icon_color || sass('primary')" />
    </div>

    <!-- titolo -->
    <p
      v-if="title"
      class="feature-card__title"
      :style="{ fontSize: `${title_size}px` }"
    >
      {{ title }}
    </p>

    <!-- testo principale (opzionale) -->
    <p v-if="text" class="feature-card__text">{{ text }}</p>

    <!-- caption secondaria (opzionale) -->
    <p v-if="caption" class="feature-card__caption">{{ caption }}</p>

    <!-- contenuto libero in coda alla card (es. un link) -->
    <slot></slot>

    <div v-if="$slots.cta" class="feature-card__cta">
      <slot name="cta"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'feature-card',

    props: {
      // nome icona vb-icon (es. 'wallet', 'shield', 'email'); se vuoto l'icona non viene mostrata
      icon: {
        type: String,
        default: '',
      },
      // titolo
      title: {
        type: String,
        default: '',
      },
      // testo descrittivo principale (opzionale)
      text: {
        type: String,
        default: '',
      },
      // testo secondario piccolo (opzionale)
      caption: {
        type: String,
        default: '',
      },
      // dimensione del titolo in px: l'unica dimensione variabile, testo e caption sono fissi in SCSS
      title_size: {
        type: Number,
        default: 16,
      },
      // colore di sfondo della card
      background_color: {
        type: String,
        default: 'white',
      },
      // sfondo del badge icona: accetta un colore solido o un gradiente (es. 'linear-gradient(...)')
      icon_background_color: {
        type: String,
        default: 'transparent',
      },
      // colore del glifo icona; se vuoto usa il primary del brand
      icon_color: {
        type: String,
        default: '',
      },
      // centra orizzontalmente icona e testi (default: allineati a sinistra)
      centered: {
        type: Boolean,
        default: false,
      },
      // se true rende circolare il badge icona (default: radius squadrato di default)
      radius: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .feature-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: $grid-gutter-20;
    border-radius: $border-radius-lg * 2;

    &--centered {
      align-items: center;
      text-align: center;
    }

    &__icon {
      display: inline-flex;
      padding: $grid-gutter-width / 3;
      margin-bottom: $grid-gutter-width / 2;
      border-radius: $border-radius-lg * 2;

      &--round {
        border-radius: 50%;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__title {
      margin: 0;
      font-weight: $vb-font-weight-semibold;
      color: $gray-900;
    }

    &__text {
      margin: ($grid-gutter-width / 6) 0 ($grid-gutter-width / 3);
      font-size: $font-size-md;
      color: $gray-700;

      &:last-child {
        margin-bottom: 0;
      }
    }

    &__caption {
      margin: ($grid-gutter-width / 6) 0 0;
      font-size: $font-size-sm;
      color: $gray-600;
    }

    &__cta {
      margin-top: $grid-gutter-width / 2;
    }
  }
</style>